// extracted by mini-css-extract-plugin
module.exports = {"icon":"FullyBookedView_icon__2AuTk","infoWrapper":"FullyBookedView_infoWrapper__KlVPO","fullyBookedView":"FullyBookedView_fullyBookedView__FmyVj"};